module.exports = __webpack_public_path__ + "r-v3/img/audio_object_bg.31097fc0.svg";